import { arComponentSchema } from "./ar-component";
import { collectionListSchema } from "./collection-list";
import { heroSchema } from "./hero";
import { heroCenteredSchema } from "./hero-centered";
import { featureGridSchema } from "./feature-grid";
import { ctaSchema } from "./cta";
import { contactFormSchema } from "./contact-form";
import { logoWallSchema } from "./logo-wall";
import { personGridSchema } from "./person-grid";
import { statCardSchema } from "./stat-card";
import { richTextSchema } from "./rich-text";
import { accordionSchema } from "./accordion";
import { careersListSchema } from "./careers-list";
import { calloutSchema } from "./callout";
import { heroMedia2ColumnSchema } from "./hero-media-2-column";
import { carouselSchema } from "./carousel";
import { resourceCardsSchema } from "./resource-cards";
import { heroMediaCenteredSchema } from "./hero-media-centered";
import { textHeroSchema } from "./text-hero";
import { articleHeaderSchema } from "./article-header";
import { chaptersSchema } from "./chapters";
import { promoSchema } from "./promo";
import { promo2ColumnSchema } from "./promo-2-column";
import { statementSchema } from "./statement";
import { timelineSchema } from "./timeline";
import { featuredPressSchema } from "./featured-press";
import { mediaSchema } from "./media";
import { promoImageSchema } from "./promo-image";
import { videoSchema } from "./video";
import { playgroundReelSchema } from "./playground-reel";
import { highlightsSchema } from "./highlights";
import { playgroundBannerSchema } from "./playground-banner";
import { playgroundCardSchema } from "./playground-card";
import { playgroundVideoSchema } from "./playground-video";
import { playgroundMediaSchema } from "./playground-media";
export const COMPONENT_CATALOG = [
    {
        componentId: "Hero",
        title: "Hero",
        description: "Opens a section of the site with an eyebrow, a title, and one sentence.",
        category: "hero",
        icon: "layout-template",
        schema: heroSchema,
    },
    {
        componentId: "HeroCentered",
        title: "Hero centered",
        description: "Opens a page with an eyebrow, a title, and one sentence, set in the middle of the page.",
        category: "hero",
        icon: "text-align-center",
        schema: heroCenteredSchema,
    },
    {
        componentId: "TextHero",
        title: "Text hero",
        description: "Opens a page with an eyebrow, a title, and a formatted description.",
        category: "hero",
        icon: "heading",
        schema: textHeroSchema,
    },
    {
        componentId: "Callout",
        title: "Callout",
        description: "Sets one short statement apart in the middle of a page.",
        category: "content",
        icon: "quote",
        schema: calloutSchema,
    },
    {
        componentId: "HeroMedia2Column",
        title: "Hero media 2 column",
        description: "Opens a page with the heading and description beside one picture or short clip.",
        category: "hero",
        icon: "columns-2",
        schema: heroMedia2ColumnSchema,
    },
    {
        componentId: "ResourceCards",
        title: "Resource cards",
        description: "A heading over a grid of outbound resource cards, split by an optional two-way toggle.",
        category: "content",
        icon: "book-open",
        schema: resourceCardsSchema,
    },
    {
        componentId: "Carousel",
        title: "Carousel",
        description: "A band of scenes a visitor travels through, each built from the subjects its kind arranges.",
        category: "media",
        icon: "gallery-horizontal",
        schema: carouselSchema,
    },
    {
        componentId: "HeroMediaCentered",
        title: "Hero media centered",
        description: "Opens a page with a centered title, a description, a call to action, and one picture or short clip.",
        category: "hero",
        icon: "image-play",
        schema: heroMediaCenteredSchema,
    },
    {
        componentId: "FeatureGrid",
        title: "Feature grid",
        description: "Responsive grid of feature cards with icons.",
        category: "content",
        icon: "layout-grid",
        schema: featureGridSchema,
        placeable: false,
    },
    {
        componentId: "Cta",
        title: "Call to action",
        description: "Centered panel with a button or an email-capture form.",
        category: "content",
        icon: "megaphone",
        schema: ctaSchema,
        placeable: false,
    },
    {
        componentId: "Accordion",
        title: "Accordion",
        description: "Ordered list of titled sections a visitor opens one at a time.",
        category: "content",
        icon: "chevrons-up-down",
        schema: accordionSchema,
    },
    {
        componentId: "CareersList",
        title: "Careers list",
        description: "Embedded Paylocity recruiting board.",
        category: "content",
        icon: "briefcase-business",
        schema: careersListSchema,
    },
    {
        componentId: "ContactForm",
        title: "Contact form",
        description: "Contact form with a short or long field set.",
        category: "form",
        icon: "mail",
        schema: contactFormSchema,
    },
    {
        componentId: "LogoWall",
        title: "Logo wall",
        description: "Row of partner or customer logos.",
        category: "media",
        icon: "images",
        schema: logoWallSchema,
        placeable: false,
    },
    {
        componentId: "PersonGrid",
        title: "Team grid",
        description: "Grid of team members with photos, roles, and bios.",
        category: "content",
        icon: "users",
        schema: personGridSchema,
    },
    {
        componentId: "StatCard",
        title: "Stat",
        description: "A single highlighted statistic.",
        category: "content",
        icon: "bar-chart",
        schema: statCardSchema,
        placeable: false,
    },
    {
        componentId: "RichText",
        title: "Rich text",
        description: "A block of formatted paragraph text.",
        category: "content",
        icon: "type",
        schema: richTextSchema,
    },
    {
        componentId: "ArticleHeader",
        title: "Article header",
        description: "Headline, date, summary, and image for a news article.",
        category: "content",
        icon: "newspaper",
        schema: articleHeaderSchema,
        placeable: false,
    },
    {
        componentId: "Chapters",
        title: "Chapters",
        description: "Editorial chapters with copy, calls to action, and image collages.",
        category: "content",
        icon: "panels-top-left",
        schema: chaptersSchema,
    },
    {
        componentId: "Promo",
        title: "Promo",
        description: "Spacious centered promotion with a formatted description and a button.",
        category: "content",
        icon: "badge-megaphone",
        schema: promoSchema,
    },
    {
        componentId: "Promo2Column",
        title: "Two-column promo",
        description: "Split statement, supporting copy, and call to action.",
        category: "content",
        icon: "columns-2",
        schema: promo2ColumnSchema,
        placeable: false,
    },
    {
        componentId: "Statement",
        title: "Statement",
        description: "Centered eyebrow and oversized editorial statement.",
        category: "content",
        icon: "quote",
        schema: statementSchema,
    },
    {
        componentId: "Timeline",
        title: "Timeline",
        description: "A run of dated milestones, each with its own picture, labels and copy.",
        category: "content",
        icon: "milestone",
        schema: timelineSchema,
    },
    {
        componentId: "CollectionList",
        title: "Collection list",
        description: "Lists a collection's published entries — news, blog posts, whatever the site publishes repeatedly.",
        category: "content",
        icon: "list",
        schema: collectionListSchema,
    },
    {
        componentId: "FeaturedPress",
        title: "Featured press",
        description: "A titled opening above the site's latest press releases, with a link to the full list.",
        category: "content",
        icon: "rss",
        schema: featuredPressSchema,
    },
    {
        componentId: "Media",
        title: "Media",
        description: "Full-width picture band with a caption, given its own picture for desktop and for mobile.",
        category: "media",
        icon: "image",
        schema: mediaSchema,
        placeable: false,
    },
    {
        componentId: "Highlights",
        title: "Highlights",
        description: "A titled grid of short facts, each one a label and the fact itself.",
        category: "content",
        icon: "list-checks",
        schema: highlightsSchema,
    },
    {
        componentId: "PromoImage",
        title: "Promo image",
        description: "An oversized promotional message beside product artwork, with its own picture for desktop and for mobile, and one call to action.",
        category: "content",
        icon: "box",
        schema: promoImageSchema,
    },
    {
        componentId: "ARComponent",
        title: "AR Component",
        description: "A mobile AR viewer link with a QR dialog for desktop visitors.",
        category: "content",
        icon: "scan-line",
        schema: arComponentSchema,
    },
    {
        componentId: "Video",
        title: "Video",
        description: "A video a visitor plays where it stands, shown as a still of itself until they do.",
        category: "media",
        icon: "circle-play",
        schema: videoSchema,
    },
    {
        componentId: "PlaygroundBanner",
        title: "Playground banner",
        description: "Test-only fixture for the media-mechanism stories — never available in production.",
        category: "media",
        icon: "flask-conical",
        schema: playgroundBannerSchema,
        testOnly: true,
    },
    {
        componentId: "PlaygroundCard",
        title: "Playground card",
        description: "Test-only fixture for the media-mechanism stories — never available in production.",
        category: "content",
        icon: "flask-conical",
        schema: playgroundCardSchema,
        testOnly: true,
    },
    {
        componentId: "PlaygroundReel",
        title: "Playground reel",
        description: "Test-only band that takes a video and nothing else — fixture for the media-kind stories.",
        category: "media",
        icon: "flask-conical",
        testOnly: true,
        schema: playgroundReelSchema,
    },
    {
        componentId: "PlaygroundVideo",
        title: "Playground video",
        description: "Test-only band that takes either a picture or a video — fixture for the media-kind stories.",
        category: "media",
        icon: "flask-conical",
        testOnly: true,
        schema: playgroundVideoSchema,
    },
    {
        componentId: "PlaygroundMedia",
        title: "Playground media",
        description: "Test-only fixture for the media-mechanism stories — never available in production.",
        category: "media",
        icon: "flask-conical",
        schema: playgroundMediaSchema,
        testOnly: true,
    },
];
/** Lookup the definition for a componentId (undefined if not in the catalog). */
export function getComponentDefinition(componentId) {
    return COMPONENT_CATALOG.find((c) => c.componentId === componentId);
}
/** The slot schema for a componentId (undefined if not in the catalog). */
export function getSlotSchema(componentId) {
    return getComponentDefinition(componentId)?.schema;
}
/** An empty slot schema — the shape returned for an unknown componentId. */
export function emptySlotSchema(componentId) {
    return { componentId, scalarSlots: [], mediaSlots: [] };
}
/**
 * The slot schema for a componentId, always resolved: the catalog's schema, or
 * an empty schema for components not in the catalog. This is what consumers
 * (CMS editor forms, page/media stubs) read — the single slot-schema authority.
 */
export function resolveSlotSchema(componentId) {
    return getSlotSchema(componentId) ?? emptySlotSchema(componentId);
}
//# sourceMappingURL=catalog.js.map